import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import moment from 'moment';

const baseQuery = fetchBaseQuery({
	baseUrl: process.env.REACT_APP_API_BASE_URL,
	prepareHeaders: (headers, { getState }) => {
		const token = getState().authentication.user.access_token || '';
		headers.set('Authorization', `Bearer ${token}`);
		headers.set('clzsid', 'bfec39c2-e51e-4996-8e72-09b1b3d50ae8_34468097');
		return headers;
	},
});

export const metadataApi = createApi({
	reducerPath: 'metadataApi',
	baseQuery,
	endpoints: (builder) => ({
		getDropdownOptions: builder.query({
			query: (name) => `/metadata/GetDropdownOptions?name=${name}`,
			transformResponse: (response) => {
				return response;
			},
		}),
		getTemplates: builder.query({
			query: () => `/metadata/GetTemplates`,
			transformResponse: (response) => {
				return response;
			},
		}),
		getRoles: builder.query({
			query: (name) => `/metadata/GetRoles?name=${name}`,
			transformResponse: (response) => {
				return response;
			},
		}),
		getAllUsers: builder.query({
			query: () => `/metadata/GetAllUsers`,
			transformResponse: (response) => {
				return response;
			},
		}),
	}),
});

export const catalogApi = createApi({
	reducerPath: 'catalogApi',
	baseQuery,
	endpoints: (builder) => ({
		getCatalogItemType: builder.query({
			query: (name) => `/catalog/GetCatalogItemType?name=${name}`,
			transformResponse: (response) => {
				return response;
			},
		}),
	}),
});
export const projectApi = createApi({
	reducerPath: 'projectApi',
	baseQuery,
	endpoints: (builder) => ({
		getProject: builder.query({
			query: (name) => `/metadata/GetDropdownOptions?name=${name}`,
			transformResponse: (response) => {
				return response;
			},
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProjectQuery } = projectApi;
export const {
	useGetDropdownOptionsQuery,
	useGetTemplatesQuery,
	useGetRolesQuery,
	useGetAllUsersQuery,
} = metadataApi;

export const { useGetCatalogItemTypeQuery } = catalogApi;
